import React, { useState, useRef } from 'react';
import { Box, Button, Dialog, DialogTitle } from '@mui/material';
import '../Spinner.css';

const MONTHS = [
  { label: 'Jan', color: '#f44336' },
  { label: 'Feb', color: '#e91e63' },
  { label: 'Mar', color: '#9c27b0' },
  { label: 'Apr', color: '#673ab7' },
  { label: 'May', color: '#3f51b5' },
  { label: 'Jun', color: '#2196f3' },
  { label: 'Jul', color: '#03a9f4' },
  { label: 'Aug', color: '#00bcd4' },
  { label: 'Sep', color: '#009688' },
  { label: 'Oct', color: '#4caf50' },
  { label: 'Nov', color: '#ff9800' },
  { label: 'Dec', color: '#795548' },
];

export default function MonthSpinner() {
  const [rotation, setRotation] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [showResult, setShowResult] = useState(false);
  const wheelRef = useRef(null);

  const startRotation = () => {
    if (!wheelRef.current) return;

    // Reset transform to prevent stacking
    wheelRef.current.style.transition = 'none';
    wheelRef.current.style.transform = `rotate(${rotation % 360}deg)`;
    void wheelRef.current.offsetHeight;

    // Spin rotation
    const spinDegrees = 360 * 5 + Math.floor(Math.random() * 360);
    setRotation(spinDegrees);

    wheelRef.current.style.transition = 'transform 4s cubic-bezier(0.25, 1, 0.5, 1)';
    wheelRef.current.style.transform = `rotate(${spinDegrees}deg)`;

    setTimeout(() => {
      const normalized = spinDegrees % 360;
      const segmentAngle = 360 / MONTHS.length;
      const index = Math.floor(((360 - normalized) % 360) / segmentAngle);
      setSelectedMonth(MONTHS[index].label);
      setShowResult(true);
    }, 4000);
  };

  return (
    <Box className="spinner-container">
      {/* Wheel Container with Triangle and Wheel */}
      <Box className="wheel-container">
        {/* Pointer */}
        <Box className="triangle-down" />

        {/* Spinner Wheel */}
        <Box
          component="ul"
          ref={wheelRef}
          className="circle"
          sx={{ transition: 'transform 0s' }}
        >
          {MONTHS.map((month, index) => (
            <li
              key={index}
              className="wheel-part"
              style={{
                transform: `rotate(${index * 30}deg) skewY(-60deg)`,
              }}
            >
              <Box
                className="text"
                sx={{
                  backgroundColor: month.color,
                  color: 'black',
                }}
              >
                {month.label}
              </Box>
            </li>
          ))}
        </Box>
      </Box>

      {/* Spin Button */}
      <Button
        variant="contained"
        size="large"
        onClick={startRotation}
        sx={{
          background: 'linear-gradient(to right, #4facfe, #00f2fe)',
          borderRadius: '50px',
          px: 6,
          py: 1.5,
          fontWeight: 'bold',
          boxShadow: 3,
          '&:hover': {
            background: 'linear-gradient(to right, #00f2fe, #4facfe)',
          },
        }}
      >
        SPIN
      </Button>

      {/* Result Dialog */}
      <Dialog open={showResult} onClose={() => setShowResult(false)}>
        <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>
          🎉 Selected Month: {selectedMonth}
        </DialogTitle>
      </Dialog>
    </Box>
  );
}
